import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LitbuySpreadsheetGuide from "../pages/article/page";
import BeginnersGuide from "../pages/articles/BeginnersGuide";
import FeaturesOverview from "../pages/articles/FeaturesOverview";
import TemplatesGuide from "../pages/articles/TemplatesGuide";
import PricingGuide from "../pages/articles/PricingGuide";
import SafetyGuide from "../pages/articles/SafetyGuide";
import ProsCons from "../pages/articles/ProsCons";
import AlternativesGuide from "../pages/articles/AlternativesGuide";
import AdvancedTips from "../pages/articles/AdvancedTips";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/litbuy-spreadsheet-guide",
    element: <LitbuySpreadsheetGuide />,
  },
  {
    path: "/litbuy-spreadsheet-beginners",
    element: <BeginnersGuide />,
  },
  {
    path: "/litbuy-spreadsheet-features",
    element: <FeaturesOverview />,
  },
  {
    path: "/litbuy-spreadsheet-templates",
    element: <TemplatesGuide />,
  },
  {
    path: "/litbuy-spreadsheet-pricing",
    element: <PricingGuide />,
  },
  {
    path: "/litbuy-spreadsheet-safety",
    element: <SafetyGuide />,
  },
  {
    path: "/litbuy-spreadsheet-pros-cons",
    element: <ProsCons />,
  },
  {
    path: "/litbuy-spreadsheet-alternatives",
    element: <AlternativesGuide />,
  },
  {
    path: "/litbuy-spreadsheet-advanced-tips",
    element: <AdvancedTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;